import { memo } from 'react';

import { JourneyIconButton } from 'ui/journey-builder/node-types/common';
import { NodeContainer } from 'ui/journey-builder/node-types/node-container';
import { JourneyNode } from 'ui/journey-builder/node-types/types';

type ActionType = 'journey_merge';

export const Node = memo((node: JourneyNode<ActionType>) => {
  return (
    <NodeContainer node={node}>
      <JourneyIconButton node={node} color="orange100" isSelectable />
    </NodeContainer>
  );
});
